import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import { colors } from '@material-ui/core';

export const successColor = green[800];
export const warningColor = amber[800];
export const errorColor = red[500];
export const iconColor = colors.blueGrey[600];
export const white = '#FFFFFF';
export const black = '#000000';
export const themeBackground = 'var(--ev-bgBody)';
export const era92Dark = 'var(--ev-textPrimary)';
export const era92Gradient =
  'linear-gradient(90deg, #fe3a6a 0%, #ff4a39 40%, #fe8c45 100%)';

export const warning = {
  contrastText: white,
  dark: colors.orange[900],
  main: colors.orange[600],
  light: colors.orange[400],
};
